import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { PagesModule } from '../pages/pages.module';
import { LegacyReviewPageComponent } from './legacy-review-page/legacy-review-page.component';
import { SlideoutPageComponent } from './slideout-page/slideout-page.component';
import { PageSharedModule } from '@workflow/dynamic-render/page/shared/page-shared.module';
import { DynamicRenderSharedModule } from '@workflow/dynamic-render/shared/shared.module';
import { DynamicPipeModule } from '@workflow/pipe/dynamic-pipe.module';

const components = [LegacyReviewPageComponent, SlideoutPageComponent];

@NgModule({
  declarations: [...components],
  exports: [...components],
  imports: [CommonModule, FormsModule, DynamicPipeModule, DynamicRenderSharedModule, PageSharedModule, PagesModule]
})
export class CustomPagesModule {}
